<template>
	<div class="content_yf">
		<div class="content_bottom_yf">
			<div class="left_bottom_yf">
				<img style="width: 90%;" src="@/assets/imgs/screen/pic_fence_box.png" alt="" />
				<h3 class="weilan_yf">车辆数据</h3>
				<ul>
					<li>
						<p class="nums_text">{{ carinfo.carCount }}</p>
						<img src="@/assets/imgs/screen/icon_fence.png" alt="" />
						<p>平台车辆数</p>
					</li>
					<li>
						<p class="nums_text">{{ carinfo.unworkedCarCount }}</p>
						<img src="@/assets/imgs/screen/icon_rail.png" alt="" />
						<p>作业中车辆数</p>
					</li>
					<li>
						<p class="nums_text">{{ carinfo.workedCarCount }}</p>
						<img src="@/assets/imgs/screen/icon_fence.png" alt="" />
						<p>空闲车辆数</p>
					</li>
				</ul>
			</div>
			<div class="fence-list-wrap">
				<h3 class="title">补能站数据</h3>
				<div class="content">
						<!-- @click="showfenceFun(index)" -->
					<div class="fence-item-box"  v-for="(item, index) in bunenglist" :key="index">
						<p>补能站名<span>{{ item.locationName }}</span></p>
						<p>充电桩<span>{{ item.stationCount }}</span> </p>
						<p>充电中<span>{{ item.chargeingStationCount  }}</span> </p>
						<p>充电电量<span>{{ item.chargeEnergy }}</span> </p>
						<p>充电次数<span>{{ item.chargeCount }}</span> </p>
					</div>
				</div>
			</div>
		</div>
		<div class="content_top_yf">
			<div class="amapContainer" id="amapContainer">
				
			</div>
			
			<div class="CarFixed">
				<ul>
					<li><span class="dlm"></span>电量：80% - 100%</li>
					<li><span class="djd"></span>电量：60% - 80%</li>
					<li><span class="zyz"></span>电量：40% - 60%</li>
					<li><span class="djc"></span>电量：20% - 40%</li>
					<li><span class="paidui"></span>电量：0% - 20%</li>
				</ul>
			
			</div>
		</div>


	</div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from "axios";
import {
	enum_plan_status
} from '../../utils/enum_var'

export default {
	data() {
		return {
			icon_rail: 1,
			fencecurrentnum: 0,
			map: null,
			timeObject: null,
			fenceData: {
				fence_number: "0", //围栏数量
				queue_car_number_fence: "0", //排队车数
				fenceInfo: [{
					queue_car_number_fence: "0", //
					go_yard_car_number_fence: "0", //前往货场车数
					average_queue_time: "0", //平均排队时长
					electronic_fence_name: "免支付围栏", //围栏名称
				},],
				go_yard_car_number_fence: "0",
			},
			zoom: 11,
			center: [117.8490190362603, 38.95143185123037],
			events: {
				click: (e) => {
					alert("map clicked");
				},
			},
			mapMarkerData: [{
				lnglat: [116.85348103403828, 37.949880342417934],
				name: "beijing",
				id: 1,
				style: 0, // 该数据的样式取值styleObjectArr对应的样式索引
			},
			{
				lnglat: [117.85476814893934, 38.94801181379824],
				name: "beijing",
				id: 2,
				style: 1,
			},
			{
				lnglat: [117.85339522594165, 38.94929643254524],
				name: "beijing",
				id: 3,
				style: 0,
			},
			],
			markers: [],
			fenceDatalist: [],
			mapList: [],
			carShow: false,
			carPlate: "",
			carStatus: "",
			carinfo:{},
			bunenglist:[]
		};
	},
	components: {
		AMapLoader,
	},
	mounted() {
		var that = this;
		// that.xing()
		that.getFenceData(true);
		this.getcarDate()
		this.getFenceData_Timer = setInterval(this.getFenceDataTimer, 5000);
		// this.getFenceDataTimer()
	},
	beforeDestroy() {
		clearInterval(this.getFenceData_Timer)
	},
	destroyed() {
		//停止计时器
		clearInterval(this.timeObject);
	},
	methods: {
		getFenceDataTimer() {
			// this.getFenceData(false);
			this.getCar();
		},
		showfenceFun(index) {
			this.fencecurrentnum = index;
			this.initMap(index);
		},
		getcarDate(){
			axios({
				method: 'get',
				url: `${this.$bigScreenApiBase}/big/screen/selectBigScreenCarCount `,
				headers:{
					token:JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user"))).token
				}
			}).then(
				(res) => {
					this.carinfo = res.data.data
				},
				(err) => {
					console.log(err);
				})
		},
		getFenceData(init) {
			if (init) {
				this.initMap(0);
			}
			this.getCar();
			// axios({
			// 	method: "get",
			// 	url: `${this.$bigScreenApiBase}/dv/fenceinfo`,
			// }).then(
			// 	(res) => {
			// 		console.log(res);
			// 		this.fenceData = res.data.data;
			// 		var fenceDatalist = [];
			// 		for (var i = 0; i < this.fenceData.fenceInfo.length; i++) {
			// 			fenceDatalist.push(
			// 				this.fenceData.fenceInfo[
			// 					i
			// 				].electronic_fence_longitude_latitude.split(";")
			// 			);
			// 		}
			// 		this.fenceDatalist = fenceDatalist;
			// 		if (init) {
			// 			this.initMap(0);
			// 		}
			// 		this.getCar();
			// 	},
			// 	(err) => {
			// 		console.log(err);
			// 	}
			// );
		},
		//请求汽车坐标
		getCar() {
			axios({
				method: "GET",
				url: `${this.$bigScreenApiBase}home/statistics/mapdisplay`,
				// headers:{
				// 	token:JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user"))).token
				// }
			}).then((res) => {
				this.mapList = res.data.data.mapEnergyCarVoList;
				this.bunenglist=res.data.data.energyStationDetailVoList
				setTimeout(()=>{
					this.setLocation();
				},500)
				
			});
		},

		initMap(index = 0) {
			AMapLoader.reset()
			AMapLoader.load({
				key: "e1e067886b395ac1aa709c2dd9982e7a", // 申请好的Web端开发者Key，首次调用 load 时必填
				version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
			})
				.then((AMap) => {
					this.map = new AMap.Map("amapContainer", {
						//设置地图容器id
						// center: [
						// 	this.fenceDatalist[index][0].split(",")[0],
						// 	this.fenceDatalist[index][0].split(",")[1],
						// ],
						center: [117.8490190362603, 38.95143185123037],
						zoom: 13,
						mapStyle: "amap://styles/darkblue",
					});
					// var fenceData0 = this.fenceDatalist[index];

					// var path = [];
					// var mybounds = [];

					// for (var i = 0; i < fenceData0.length; i++) {
					// 	var zuobiao = new AMap.LngLat(
					// 		fenceData0[i].split(",")[0],
					// 		fenceData0[i].split(",")[1]
					// 	);
					// 	// var zuobiao1 = new AMap.Bounds(fenceData0[i].split(",")[0],fenceData0[i].split(",")[1])
					// 	path.push(zuobiao);
					// 	// mybounds.push(zuobiao1)
					// }
					// console.log(path)
					// var polygon = new AMap.Polygon({
					// 	path: path,
					// 	fillColor: "rgba(5, 255, 255, 0.05)", // 多边形填充颜色
					// 	borderWeight: 5, // 线条宽度，默认为 1
					// 	strokeColor: "#05FFFF", // 线条颜色
					// });
					// this.map.add(polygon);

					// 缩放地图到合适的视野级别
					// this.map.setFitView([polygon]);
					// this.map.setBounds(mybounds);
					var trafficLayer = new AMap.TileLayer.Traffic({
						zIndex: 10,
					});
					this.map.add(trafficLayer);

				})
				.catch((e) => {
					console.log(e);
				});
		},
		setLocation() {
			// 渲染多个坐标点
			this.markers.forEach(item => {
				this.map.remove(item);
			})
			this.markers = [];

			this.mapList.filter(it => it.soc).forEach(val => {
				var markerContentstyle = '<div class="custom-content-marker" >';
				switch (true) {
					case val.soc<20:
						markerContentstyle =
							'<div class="custom-content-marker" style="background-color: rgb(192, 0, 0)">';
						break;
					case val.soc>=20&&val.soc<40:
						markerContentstyle =
							'<div class="custom-content-marker" style="background-color: rgb(230, 186, 11)">';
						break;
					case val.soc>=40&&val.soc<60:
						markerContentstyle =
							'<div class="custom-content-marker" style="background-color:rgb(239, 247, 2)">';
						break;
					case val.soc>=60&&val.soc<80:
						markerContentstyle =
							'<div class="custom-content-marker" style="background-color: rgb(0, 225, 251)">';
						break;
					case val.soc>=80:
						markerContentstyle =
							'<div class="custom-content-marker" style="background-color:rgb(11, 252, 67)">';
						break;
				}
				// const his = new Date(val.create_time);
				// const now = new Date();
				// const min = parseInt(now - his) / 1000 / 60;

				// if (min > 10) {
				// 	markerContentstyle = markerContentstyle.replace('custom-content-marker',
				// 		'custom-content-markerLx')
				// }
				const markerContent = markerContentstyle + ` <div class='pop-layer'> 
								<span class='plate'>车牌号码:${val.plate}</span> 
								<span class='plate'>所属车队:${val.shortname}</span> 
								<span class='status'>车辆状态:${val.vehstate }</span>
								<span class='plate'>充电状态:${val.chargestate}</span> 
						</div>
					</div>`

				const position = new AMap.LngLat(val.lng, val.lat); // Marker经纬度
				const marker = new AMap.Marker({
					position: position,
					content: markerContent, // 将 html 传给 content
				});
				this.markers.push(marker);
				this.map.add(marker);
			});
		},
		//鼠标滑过坐标点
		// mouseover(e, index) {
		// 	console.log('鼠标滑过了',index);
		// 	// console.log(this.mapList[index].plate);
		// 	if (this.mapList[index].status == 10) {
		// 		this.mapList[index].status = "待接单";
		// 	} else if (this.mapList[index].status == 11) {
		// 		this.mapList[index].status = "待车队确认";
		// 	} else if (this.mapList[index].status == 20) {
		// 		this.mapList[index].status = "待缴费";
		// 	} else if (this.mapList[index].status == 30) {
		// 		this.mapList[index].status = "待审核";
		// 	} else if (this.mapList[index].status == 35) {
		// 		this.mapList[index].status = "待排队";
		// 	} else if (this.mapList[index].status == 36) {
		// 		this.mapList[index].status = "排队中";
		// 	} else if (this.mapList[index].status == 37) {
		// 		this.mapList[index].status = "排队完成";
		// 	} else if (this.mapList[index].status == 40) {
		// 		this.mapList[index].status = "待进场";
		// 	} else if (this.mapList[index].status == 42) {
		// 		this.mapList[index].status = "进卡口";
		// 	} else if (this.mapList[index].status == 43) {
		// 		this.mapList[index].status = "回皮";
		// 	} else if (this.mapList[index].status == 44) {
		// 		this.mapList[index].status = "装车";
		// 	} else if (this.mapList[index].status == 45) {
		// 		this.mapList[index].status = "过重";
		// 	} else if (this.mapList[index].status == 46) {
		// 		this.mapList[index].status = "无作业";
		// 	} else if (this.mapList[index].status == 60) {
		// 		this.mapList[index].status = "完成";
		// 	} else if (this.mapList[index].status == 61) {
		// 		this.mapList[index].status = "拒绝接单";
		// 	} else if (this.mapList[index].status == 62) {
		// 		this.mapList[index].status = "进场前取消";
		// 	} else if (this.mapList[index].status == 63) {
		// 		this.mapList[index].status = "进场后取消";
		// 	} else if (this.mapList[index].status == 64) {
		// 		this.mapList[index].status = "审核未通过";
		// 	} else if (this.mapList[index].status == 65) {
		// 		this.mapList[index].status = "抢单车队拒绝";
		// 	} else if (this.mapList[index].status == 66) {
		// 		this.mapList[index].status = "审核前取消";
		// 	} else if (this.mapList[index].status == 49) {
		// 		this.mapList[index].status = "取消待审核";
		// 	} else if (this.mapList[index].status == 68) {
		// 		this.mapList[index].status = "取消未通过";
		// 	} else if (this.mapList[index].status == null) {
		// 		this.mapList[index].status = "无状态";
		// 	}
		// 	// const windowContent = `<div>${this.mapList[index].plate}</div><div>${this.mapList[index].status}</div>`;
		// 	// var infoWindow = new AMap.InfoWindow({content: windowContent ,offset: new AMap.Pixel(0, 0)})
		// 	// infoWindow.open(this.map ,e.lnglat)
		// 	this.carShow = true;
		// 	this.carPlate = this.mapList[index].plate;
		// 	this.carStatus = this.mapList[index].status;
		// },
		// mouseout() {
		// 	// this.carShow = false;
		// },

		xing() {
			var that = this;
			setInterval(function () {
				if (that.icon_rail == 1) {
					that.icon_rail = 2;
				} else if (that.icon_rail == 2) {
					that.icon_rail = 1;
				}
			}, 800);
		},
	},
};
</script>

<style lang="scss" >
.amap-marker {
	&:hover {
		z-index: 13 !important;
	}
}

.custom-content-markerLx {
	position: absolute;
	width: 10px;
	height: 10px;
	// background-color: rgb(225, 182, 27);
	// border: 1px solid rgb(4, 35, 87);
	z-index: -1;

	&:hover {
		z-index: 99;

		.pop-layer {
			display: flex;
			z-index: 9;
		}
	}

	.pop-layer {

		background-color: #1a2970;
		border: 2px solid #1a3782;
		color: white;
		position: absolute;
		flex-direction: column;
		padding: 6px;
		border-radius: 6px;
		overflow: hidden;
		bottom: 100%;
		left: 50%;
		transform: translatex(-50%);
		pointer-events: none;
		display: none;
		z-index: -1;

		.plate {
			// color: white;
			// background-color: #1e68bb;
			// border-radius: 2px;
			// border: white 0.5px solid;
			// text-align: center;
			// padding: 2px 9px;
			display: inline-block;
			// box-shadow: 0 0 1px 2px #1e68bb, 0 0 1px 2px #1e68bb inset;
			min-width: 90px;
			height: 24px;
			white-space: nowrap;
		}

		.status {
			line-height: 1.6;
			margin-top: 4px;
			// font-size: 16px;
			white-space: nowrap;
		}

	}
}

.custom-content-marker {
	position: absolute;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	// background-color: rgb(225, 182, 27);
	// border: 1px solid rgb(4, 35, 87);
	z-index: -1;

	&:hover {
		z-index: 99;

		.pop-layer {
			display: flex;
			z-index: 9;
		}
	}

	.pop-layer {

		background-color: #1a2970;
		border: 2px solid #1a3782;
		color: white;
		position: absolute;
		flex-direction: column;
		padding: 6px;
		border-radius: 6px;
		overflow: hidden;
		bottom: 100%;
		left: 50%;
		transform: translatex(-50%);
		pointer-events: none;
		display: none;
		z-index: -1;

		.plate {
			// color: white;
			// background-color: #1e68bb;
			// border-radius: 2px;
			// border: white 0.5px solid;
			// text-align: center;
			// padding: 2px 9px;
			display: inline-block;
			// box-shadow: 0 0 1px 2px #1e68bb, 0 0 1px 2px #1e68bb inset;
			min-width: 90px;
			height: 24px;
			white-space: nowrap;
		}

		.status {
			line-height: 1.6;
			margin-top: 4px;
			// font-size: 16px;
			white-space: nowrap;
		}

	}
}
</style>

<style scoped lang="scss">
.content_yf {
	width: 100%;
	height: 100%;
	display: flex;
}

.content_top_yf {
	flex: 1;
	padding-right: 20px;
	height: 90%;
	margin: 20px auto 29px;

	.amapContainer {
		width: 100%;
		height: 100%;
		position: relative;
		border-radius: 70px;
		border: 2px solid #1a3782;
	}
}

.content_bottom_yf {
	width: 26%;
	display: flex;
	flex-direction: column;
	padding-top: 16px;
	//   width: 1845px;
	// justify-content: space-between;
	// margin-left: 29px;
	// border:1px solid red;
}

.left_bottom_yf {
	position: relative;
	left: 15px;

	.weilan_yf {
		position: absolute;
		top: 10px;
		left: -30px;
		font-size: 18px;
		font-family: Source Han Sans CN;
		text-align: center;
		width: 100%;
		font-weight: bold;
		color: #ffffff;
	}

	ul {
		position: absolute;
		left: 50px;
		top: 78px;
		display: flex;
		font-size: 14px;
		font-family: Source Han Sans CN;
		width: 386px;
		justify-content: space-between;
		font-weight: bold;
		text-align: center;
		color: #ffffff;

		.nums_text {
			font-size: 18px;
			font-weight: bold;
			color: #23fee2;
		}

		img {
			margin: -4px auto 10px;
			width: 107px;
			height: 100px;
			animation: rotate3d 2s linear 0s infinite alternate;
		}

		li {
			&:nth-child(2) {
				img {
					animation: rotate3d 2s linear 0.5s infinite alternate;
				}
			}

			&:nth-child(3) {
				img {
					animation: rotate3d 2s linear 1.5s infinite alternate;
				}
			}
		}
	}
}

.CarFixed {
	position: absolute;
	right: 20px;
	bottom: 0px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #FFFFFF;
	z-index: 9;

	// position: absolute;
	// right: 0;
	// bottom: 0;
	// // background-color: white;
	// border-radius: 10px;
	// font-size: 20px;
	// width: 250px;
	// padding: 15px 10px;
	// // border: 2px solid #f67b50;
	// color: #f67b50;
	// z-index: 9;

	li {
		margin-bottom: 25px;

		.zhuangzai {
			width: 24px;
			height: 24px;
			vertical-align: middle;
		}

		span {
			width: 12px;
			height: 12px;
			margin: 6px 10px 6px 6px;
			vertical-align: middle;
			display: inline-block;
			border-radius: 50%;

			&.paidui {
				background-color: rgb(192, 0, 0);
			}

			&.zyz {
				background-color: rgb(239, 247, 2);
			}

			&.djd {
				background-color: rgb(0, 225, 251);
			}

			&.djc {
				background-color: rgb(230, 186, 11);
			}
			&.dlm {
				background-color: rgb(11, 252, 67);
			}
		}
	}
}

.fence-list-wrap {
	margin-top: 16px;
	box-sizing: border-box;
	position: relative;
	width: 95%;
	margin-left: 16px;

	// height: 300px;
	padding-top: 50px;

	.title {
		position: absolute;
		top: 0;
		left: 0;
		color: #ffffff;
		width: 100%;
		font-size: 18px;
		text-align: center;
		height: 60px;
		line-height: 60px;
		background-image: url(../../assets/imgs/screen/pic_fence_box.png);
		background-repeat: no-repeat;
		// background-size: contain;
		// border:1px solid red;
		background-size: cover;
		width: 95%;
	}

	.content {
		border: 2px solid rgb(2, 83, 148);
		border-top: none;
		box-sizing: border-box;
		width: 95%;
		height: 69vh;
		padding-top: 20px;

		overflow-y: auto;

		.fence-item-box {
			border: 1px solid rgb(36, 19, 196);
			margin: 10px auto;
			padding: 5px 10px;
			width: 90%;
			color: white;
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(2, 1fr);
			gap: 10px 5px;
			position: relative;
			cursor: pointer;
			&:hover{
				border: 1px solid rgb(201, 12, 106);
				&::after{
					background-color: rgb(201, 12, 106);
				}
			}

			&::after {
				position: absolute;
				top: 0;
				left: -2px;
				border-radius: 2px;
				content: "";
				display: inline-block;
				width: 4px;
				height: 10px;
				background-color: #23fee2;
			}

			p {
				// display: flex;
				// justify-content: space-between;
				font-size: 15px;

				span {
					padding-left: 1em;
					color: #23fee2;
				}
			}
		}



		// top: 50px;
		// left: 0;
		// // height: 246px;
		// display: grid;
		// grid-template-columns: 1fr 1fr;
		// grid-template-rows: 1fr 1fr;
		// gap: 10px 20px;
		// padding: 10px;
		// overflow: hidden;
		// // border: 1px solid red;
		// box-sizing: border-box;

		// .fence-item-box {
		// 	// border: 1px solid red;
		// 	background-image: url(../../assets/imgs/screen/pic_box.png);
		// 	background-size: 100% 100%;
		// 	background-repeat: no-repeat;
		// 	padding-top: 5%;
		// 	padding-left: 10%;
		// 	box-sizing: border-box;

		// 	p {
		// 		color: white;
		// 		font-size: 15px;

		// 		span {
		// 			padding-left: 1em;
		// 			color: #23fee2;
		// 		}
		// 	}
		// }

	}

	// <img src="@/assets/imgs/screen/pic_box.png" alt="" />
	// 					<img src="@/assets/imgs/screen/pic_box1.png"

	// <img src="@/assets/imgs/screen/pic_box.png" alt="" />

	// margin-top: 20px;
	// position: relative;
	// left: 15px;

	// >img {
	// 	// width: 550px;
	// 	// height: 650px;
	// }

	// .zuoye_yf {
	// 	position: absolute;
	// 	top: 10px;
	// 	// left: 160px;
	// 	text-align: center;
	// 	width: 90%;
	// 	font-size: 18px;
	// 	font-family: Source Han Sans CN;
	// 	font-weight: bold;
	// 	color: #ffffff;
	// }

	// .dateBox {
	// 	position: absolute;
	// 	width: 100%;
	// 	height: 90%;
	// 	// display: flex;
	// 	// justify-content: space-around;
	// 	// flex-wrap: wrap;
	// 	top: 100px;
	// 	// box-sizing: border-box;
	// 	left: 0;

	// 	ul {
	// 		display: flex;
	// 		width: 100%;
	// 		flex-wrap: wrap;
	// 		box-sizing: border-box;
	// 		justify-content: space-between;
	// 		padding: 0 2%;

	// 		li {
	// 			width: 48%;
	// 			height: 156px;
	// 			overflow: hidden;
	// 			position: relative;
	// 			box-sizing: border-box;
	// 			cursor: pointer;
	// 			margin-bottom: 10px;

	// 			.pic_box1 {
	// 				position: absolute;
	// 				left: 0;
	// 				top: 0;
	// 				width: 100%;
	// 				height: 157px;
	// 			}

	// 			.work_text_yf {
	// 				position: absolute;
	// 				left: 25px;
	// 				top: 16px;
	// 				font-size: 14px;
	// 				font-family: Source Han Sans CN;
	// 				font-weight: 400;
	// 				width: 188px;
	// 				color: #ffffff;

	// 				p {
	// 					margin-bottom: 6px;
	// 					width: 80%;
	// 					overflow: hidden;

	// 					&:nth-child(1) {
	// 						font-size: 16px;
	// 						font-weight: bold;
	// 						margin-bottom: 20px;
	// 					}

	// 					span {
	// 						float: right;
	// 						color: rgba(31, 224, 208, 1);
	// 					}

	// 					&:nth-child(2),
	// 					&:nth-child(3),
	// 					&:nth-child(4) {
	// 						margin-left: 30px;
	// 					}
	// 				}
	// 			}
	// 		}

	// 		.fencecurrent {
	// 			background: rgba(6, 71, 201, 50);
	// 		}
	// 	}
	// }

}

@keyframes rotate3d1 {
	0% {
		transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		/* Safari 和 Chrome */
	}

	100% {
		transform: rotateY(70deg);
		-webkit-transform: rotateY(70deg);
		/* Safari 和 Chrome */
	}
}
</style>